'use client'

import {Box} from '@blocks'
import {
   ROUTE_HERO_BANNER_OVERLAY_EDGE_PADDING_BOTTOM_PX,
   ROUTE_HERO_BANNER_OVERLAY_PADDING_TOP_EXTRA_PX
} from '@constants'
import type {ReactNode} from 'react'

type Payload = Readonly<{
   children: ReactNode
   headlineDesktop: boolean
   siteLayoutHeaderHeightPx: number
}>

/**
 * Centres route hero copy in the visible banner area below the fixed header.
 */
export const RouteHeroHeadlineOverlay = ({
   children,
   headlineDesktop,
   siteLayoutHeaderHeightPx
}: Payload) => {
   return (
      <Box
         style={{
            position: 'absolute',
            inset: 0,
            zIndex: 2,
            display: 'flex',
            flexDirection: 'column',
            paddingTop:
               siteLayoutHeaderHeightPx +
               ROUTE_HERO_BANNER_OVERLAY_PADDING_TOP_EXTRA_PX,
            paddingBottom: headlineDesktop
               ? ROUTE_HERO_BANNER_OVERLAY_EDGE_PADDING_BOTTOM_PX.desktop
               : ROUTE_HERO_BANNER_OVERLAY_EDGE_PADDING_BOTTOM_PX.mobile,
            paddingLeft: 16,
            paddingRight: 16,
            boxSizing: 'border-box',
            pointerEvents: 'none'
         }}
      >
         <Box
            style={{
               flex: 1,
               minHeight: 0,
               display: 'flex',
               flexDirection: 'column',
               alignItems: 'center',
               justifyContent: 'center'
            }}
         >
            {children}
         </Box>
      </Box>
   )
}
